import axios from '../../../../axiosRetailReleases';

const currentURL = window.location.href;
const url = new URL(currentURL);
const domain = url.origin;

// danh sach đơn vị tính
const getListUnitAxios = (data, header) => {
    return axios({
        url: '/unit/list-all',
        method: 'GET',
        params: {
            ...data,
            link: '/unit-manger',
            domain: domain,
        },
        headers: header,
    });
};

// thêm mới đơn vị tính
const createUnitAxios = (data, header) => {
    return axios({
        url: '/unit/create',
        method: 'POST',
        data: {
            ...data,
            link: '/unit-manger',
            domain: domain,
        },
        headers: header,
    });
};

// lay danh sach don vi cua san pham
const getUnitByProduct = (data, header) => {
    return axios({
        url: '/unit/list-unit/by-product',
        method: 'GET',
        params: {
            ...data,
            link: '/unit-manger',
            domain: domain,
        },
        headers: header,
    });
};

// lay danh sach don vi tinh cua danh muc
const getUnitByCategory = (data, header) => {
    return axios({
        url: '/process-config/get-unit-by-category',
        method: 'GET',
        params: {
            ...data,
            link: '/unit-manger',
            domain: domain,
        },
        headers: header,
    });
};

export { getListUnitAxios, createUnitAxios, getUnitByProduct, getUnitByCategory };
